(() => {
  const TRANSITION_PROP = 'max-height';
  const FALLBACK_MS = 850;

  const forceReflow = (el) => {
    void el.offsetHeight;
  };

  const cancelPending = (details) => {
    if (details._collapsibleTimer) {
      clearTimeout(details._collapsibleTimer);
      details._collapsibleTimer = null;
    }
    if (details._collapsibleOnEnd) {
      const content = details.querySelector('.accordion__content');
      content?.removeEventListener('transitionend', details._collapsibleOnEnd);
      details._collapsibleOnEnd = null;
    }
  };

  const onTransitionEnd = (content, handler) => {
    const onEnd = (event) => {
      if (event.target !== content || event.propertyName !== TRANSITION_PROP) return;
      handler();
    };
    return onEnd;
  };

  const animateOpen = (details, content) => {
    cancelPending(details);
    details.dataset.animating = '1';
    details.classList.remove('is-collapsing');
    details.setAttribute('open', '');

    // Pin current height in px (handles leftover max-height: none), then collapse to 0
    content.style.maxHeight = `${content.scrollHeight}px`;
    forceReflow(content);
    content.style.maxHeight = '0px';
    forceReflow(content);

    const targetHeight = content.scrollHeight;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.maxHeight = `${targetHeight}px`;
      });
    });

    const finish = () => {
      cancelPending(details);
      content.style.maxHeight = 'none';
      details.dataset.animating = '';
    };

    const onEnd = onTransitionEnd(content, finish);
    details._collapsibleOnEnd = onEnd;
    content.addEventListener('transitionend', onEnd);
    details._collapsibleTimer = window.setTimeout(finish, FALLBACK_MS);
  };

  const animateClose = (details, content) => {
    cancelPending(details);
    details.dataset.animating = '1';
    details.classList.add('is-collapsing');

    content.style.maxHeight = `${content.scrollHeight}px`;
    forceReflow(content);
    content.style.maxHeight = '0px';

    const finish = () => {
      cancelPending(details);
      details.removeAttribute('open');
      details.classList.remove('is-collapsing');
      details.dataset.animating = '';
      content.style.maxHeight = '';
    };

    const onEnd = onTransitionEnd(content, finish);
    details._collapsibleOnEnd = onEnd;
    content.addEventListener('transitionend', onEnd);
    details._collapsibleTimer = window.setTimeout(finish, FALLBACK_MS);
  };

  const initDetails = (details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');
    if (!summary || !content || details.dataset.jsInit === '1') return;
    details.dataset.jsInit = '1';

    if (details.hasAttribute('open')) {
      content.style.maxHeight = 'none';
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.dataset.animating === '1') return;

      if (details.hasAttribute('open')) {
        animateClose(details, content);
      } else {
        animateOpen(details, content);
      }
    });
  };

  const init = () => {
    document
      .querySelectorAll('.collapsible-content .accordion details, .product__accordion.accordion details')
      .forEach(initDetails);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
